import { downgradeInjectable } from '@angular/upgrade/static';
import {
  ScheduleModalFacade,
  ScheduleOwnerFacade,
  ScheduleSlackFacade,
  ScheduleSubscriptionFacade,
} from '@mode/shared/schedules/contract';
import * as angular from 'angular';

export const DowngradedSharedSchedulesDomainModule = angular
  .module('downgraded-shared-schedules-domain', [])
  .service('ScheduleOwnerFacade', downgradeInjectable(ScheduleOwnerFacade))
  .service('ScheduleModalFacade', downgradeInjectable(ScheduleModalFacade))
  .service('ScheduleSlackFacade', downgradeInjectable(ScheduleSlackFacade))
  .service('ScheduleSubscriptionFacade', downgradeInjectable(ScheduleSubscriptionFacade)).name;
